'use strict';

function fillWildcards(keyframes) {
    for (let i = 1; i < keyframes.length; i++) {
        keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
    }
}

exports.fillWildcards = fillWildcards;
//# sourceMappingURL=fill-wildcards.cjs.map
